import React, { Component } from 'react'
import { Button, Modal, ToolTip } from '@driftt/tide'
import ArticleModalContent from 'components/ModalContent/ArticleModalContent'
import { connect } from 'react-redux'
import { getCanonicalDomain } from 'modules/settings/selectors'
import { getSlug, getIsArticleSaved, getbackEndCopyOfArticleStatus } from 'modules/knowledgebase/selectors'
import DeleteArticleContent from 'components/DeleteModalContent/DeleteArticleContent'
import { articleStatus } from 'modules/knowledgebase/model'

import './style.css'

class ArticleActionButtons extends Component {
  tooltipMessage = 'You can only view Private or Public articles'
  
  state = {
    isDeleteModalOpen: false,
    isArticleModalOpen: false
  }
  
  handleViewClick = () => {
    window.open(`https://${this.props.hostName}/article/${this.props.slug}?v=${Date.now()}`, "_blank")
  }
  
  toggleDeleteArticleModal = () => {
    this.setState(prevState => this.setState({
      isDeleteModalOpen: !prevState.isDeleteModalOpen
    }))
  }
  
  toggleArticleSettingsModal = () =>
    this.setState(prevState => this.setState({
      isArticleModalOpen: !prevState.isArticleModalOpen
    }))
  
  render() {
    const { isDeleteModalOpen, isArticleModalOpen } = this.state
    const { isEditing, isArticleSaved, backEndCopyOfArticleStatus } = this.props
    
    return (
      <div className="article-action-buttons-wrapper">
        {backEndCopyOfArticleStatus === articleStatus.DRAFT ?
          <ToolTip flow="down" component={this.tooltipMessage}>
            <Button
              icon="eye"
              iconAlignment="left"
              type="tertiary"
              className="article-action-view-button"
              onClick={this.handleViewClick}
              disabled={backEndCopyOfArticleStatus === articleStatus.DRAFT || !isArticleSaved}
            >
              View
            </Button>
          </ToolTip> :
          <Button
            icon="eye"
            iconAlignment="left"
            type="tertiary"
            className="article-action-view-button"
            onClick={this.handleViewClick}
          >
            View
          </Button>
        }
        
        <Button
          icon="settings-1"
          iconAlignment="left"
          type="tertiary"
          onClick={this.toggleArticleSettingsModal}
        >
          Settings
        </Button>
        
        <Button
          icon="trash"
          iconAlignment="left"
          type="tertiary"
          onClick={this.toggleDeleteArticleModal}
        >
          Delete
        </Button>
  
        {isDeleteModalOpen &&
          <DeleteArticleContent
            isFromEditor={isEditing}
            onCloseModal={this.toggleDeleteArticleModal}
          />
        }
  
        <Modal
          open={ isArticleModalOpen }
          size="medium"
          onClose={this.toggleArticleSettingsModal}
        >
          <ArticleModalContent isEditing={isEditing} onCloseModal={this.toggleArticleSettingsModal}/>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  hostName: getCanonicalDomain(state),
  slug: getSlug(state),
  backEndCopyOfArticleStatus: getbackEndCopyOfArticleStatus(state),
  isArticleSaved: getIsArticleSaved(state)
})

export default connect(mapStateToProps)(ArticleActionButtons)
